import { createStore } from "./_createStore";

type MaintenanceState = {
  isMaintenanceOn: boolean;
  setMaintenance: (
    state: Partial<Omit<MaintenanceState, "setMaintenance">>,
  ) => void;
};

export const useMaintenanceStore = createStore<MaintenanceState>(
  (set) => ({
    isMaintenanceOn: false,
    setMaintenance: (state) => set(state),
  }),
  "MaintenanceStore",
);
